// api
import createNewTicketAPICall from './api/crateNewTicket';
import getTicketDetailApiCall from './api/getTicketDetail';
import updateTicketDetailApiCall from './api/updateTicketDetail';
import cancelTicketApiCall from './api/cancelTicket';
import moveTicketToTMSApiCall from './api/moveTicketToTMS';
// settings
import { STATES } from './constants';
import moment from 'moment';
import ADDITIONAL_SERVICES from './constants/additional-services';
import ticketFormDefaultValues from './components/ticket-form/config/ticket-form-default-values';

//
//
//
//
//
//
// defaultValues
//
//
//
//
//
//
//

const getDefaultInitialFormValues = () => deepCopy(ticketFormDefaultValues);

const getDefaultLoad = () => {
  return {
    number_of_items: 1,
    load_type: 'eupallet',
    item_length: '',
    item_width: '',
    item_height: '',
  };
};

const defaultValues = {
  getDefaultInitialFormValues,
  getDefaultLoad,
};

//
//
//
//
//
//
// utils
//
//
//
//
//
//
//

const deepCopy = (object) => JSON.parse(JSON.stringify(object));

const navigateToList = async ({ history }) => {
  history.push('/emergencies/');
};

const getFormatedId = (id) => {
  const numberOfWantedDigits = 4;
  const numberOfActualDigits = id.toString().length;
  const amountOfMissingDigits = numberOfWantedDigits - numberOfActualDigits;
  let formatedId = '';
  for (let i = 0; i < amountOfMissingDigits; i++) formatedId = formatedId + '0';
  formatedId = formatedId + id;
  return formatedId;
};

const utils = {
  deepCopy,
  navigateToList,
  getFormatedId,
};

//
//
//
//
//
//
// business
//
//
//
//
//
//
//

const colorStates = {
  [STATES.REJECTED]: '#CC000A',
  [STATES.PENDING]: '#2396DC',
  [STATES.QUOTE_SENT]: '#94A6B8',
  [STATES.EXPIRED]: '#FF6400',
  [STATES.ACCEPTED]: '#0FB44B',
  [STATES.CANCELLED]: '#CCD6E0',
  [STATES.DONE]: '#0FB44B',
  [STATES.OUT_OF_SCOPE]: '#CCD6E0',
  [STATES.DRAFT]: '#eeb93f',
};

const getTicketColor = (ticket) => {
  const ticketState = ticket.synthetic_state;
  return [STATES.DONE, STATES.ACCEPTED].includes(ticketState)
    ? colorStates[ticketState]
    : colorStates[STATES.PENDING];
};

const canTicketBeEdited = (ticket) => {
  if (!!!ticket) return false;
  const state = ticket.synthetic_state;
  const statesThatCanEdit = [
    STATES.DRAFT,
    STATES.PENDING,
    STATES.QUOTE_SENT,
    STATES.REJECTED,
    STATES.EXPIRED,
  ];
  return statesThatCanEdit.includes(state);
};

// ticket has deadline warning if the deadline is less than x minutes from now
const hasDeadlineWarning = (ticket) => {
  // check if state can have warning (we dont want to show warnings for cancelled tickets)
  const statesThatCanHaveDeadlineWarning = [
    STATES.PENDING,
    STATES.REJECTED,
    STATES.EXPIRED,
  ];
  const canHaveDeadlineWarning = statesThatCanHaveDeadlineWarning.includes(
    ticket.synthetic_state
  );
  if (!canHaveDeadlineWarning) return false;
  //   check if customer did set a deadline
  const deadline = ticket.order_data.complementary_info.customer_deadline;
  const hasDeadline =
    deadline !== '' &&
    deadline !== null &&
    typeof deadline !== 'undefined' &&
    moment(deadline).isValid();
  if (!hasDeadline) return false;
  // see if now, is after deadline - x minutes
  // minutesForWarning is 60
  // deadline is 14:40
  // fromDate, now, is 13:50,
  // toDate, deadline - minutesForWarning, is 13:30
  // if fromDate is after toDate, show we have warning
  const minutesForWarning = 60;
  const toDate = moment(deadline).subtract(minutesForWarning, 'minutes');
  const now = moment();
  const fromDate = now;
  return fromDate.isAfter(toDate, 'minutes');
};

const bussiness = {
  canTicketBeEdited,
  getTicketColor,
  colorStates,
  hasDeadlineWarning,
};

//
//
//
//
//
//
// data transformation
//
//
//
//
//
//
//

const cleanTimeFromBackend = (time) => {
  if (time.length === 8) {
    time = time.slice(0, 5);
  }
  return time;
};

const cleanNullableNumberForBackend = (numberInStringFormat) => {
  if (!numberInStringFormat) return null;
  if (numberInStringFormat === '') return null;
  return parseFloat(numberInStringFormat) || null;
};

const prepareTimeForBackend = (time) => {
  if (time.length === 5) return `${time}:00`;
  return time;
};

const getDatetimeFromSeparateDateAndTime = ({ date, time }) => {
  if (time === '' || date === '') return '';
  const timeParts = time.split(':');
  const hours = timeParts[0];
  const minutes = timeParts[1];
  const dateTime = moment(date).hours(hours).minutes(minutes);
  const dateTimeInIsoFormat = dateTime.toISOString();
  return dateTimeInIsoFormat;
};

const getSeparateDateAndTimeFromDatetime = ({ dateTime }) => {
  if (!dateTime || dateTime === '')
    return {
      date: '',
      time: '',
    };
  const dateTimeMoment = moment(dateTime).local();
  const date = dateTimeMoment.format('YYYY-MM-DD');
  const time = dateTimeMoment.format('HH:mm');
  return {
    date,
    time,
  };
};

const getTicketDtoFromFormValues = ({ values }) => {
  const dto = { ...values };

  //   set notification_transports
  if (values.custom.transport.selected_notification_transport === 'whatsapp') {
    dto.shipper_data.notification_transports = [
      {
        transport: 'whatsapp',
        phone_number: values.custom.transport.phone,
      },
    ];
  }
  if (values.custom.transport.selected_notification_transport === 'email') {
    dto.shipper_data.notification_transports = [
      {
        transport: 'email',
        email: values.custom.transport.email,
      },
    ];
  }
  //   delete dto.custom.transport;
  //   set times
  dto.order_data.pickup.time_from = prepareTimeForBackend(
    dto.order_data.pickup.time_from
  );
  dto.order_data.pickup.time_to = prepareTimeForBackend(
    dto.order_data.pickup.time_to
  );
  dto.order_data.dropoff.time_from = prepareTimeForBackend(
    dto.order_data.dropoff.time_from
  );
  dto.order_data.dropoff.time_to = prepareTimeForBackend(
    dto.order_data.dropoff.time_to
  );
  //   set load list
  dto.order_data.loads_data.loads = dto.order_data.loads_data.loads.map(
    (load) => ({
      ...load,
      item_height: cleanNullableNumberForBackend(load.item_height),
      item_length: cleanNullableNumberForBackend(load.item_length),
      item_width: cleanNullableNumberForBackend(load.item_width),
    })
  );
  //   set loads total
  const totals = dto.order_data.loads_data.totals;
  dto.order_data.loads_data.cubic_meters = cleanNullableNumberForBackend(
    totals.cubic_meters
  );
  dto.order_data.loads_data.linear_meters = cleanNullableNumberForBackend(
    totals.linear_meters
  );
  dto.order_data.loads_data.total_weight = cleanNullableNumberForBackend(
    totals.total_weight
  );
  //  deadline
  const deadlineDate = dto.order_data.complementary_info.customer_deadline_date;
  const deadlineTime = dto.order_data.complementary_info.customer_deadline_time;
  const deadline = getDatetimeFromSeparateDateAndTime({
    date: deadlineDate,
    time: deadlineTime,
  });
  dto.order_data.complementary_info.customer_deadline = deadline;
  if (deadline === '')
    dto.order_data.complementary_info.customer_deadline = null;

  const otherAdditionalServices =
    dto.order_data.complementary_info.other_additional_services;

  !!otherAdditionalServices &&
    dto.order_data.complementary_info.additional_services.push(
      otherAdditionalServices
    );

  if (dto.order_data.service_type.vehicle_type === 'None') {
    dto.order_data.service_type.vehicle_type = null;
  }

  dto.create_draft_on_validation_error = true;

  return dto;
};

const convertNullToEmptyString = (value) => {
  if (value === 0) return null;
  return value;
};

const knownAdditionalServices = ADDITIONAL_SERVICES.map(
  (service) => service.value
);

const splitAdditionalServices = (additionalServices) => {
  const known = additionalServices.filter((service) =>
    knownAdditionalServices.includes(service)
  );
  const unknown = additionalServices.filter(
    (service) => !knownAdditionalServices.includes(service)
  );

  return [known, unknown.join('\n')];
};

const getInitialFormValuesFromTicketDto = ({ ticketDto }) => {
  let initialValues = getDefaultInitialFormValues();
  const copyTicketDto = deepCopy(ticketDto);

  // fill shipper data
  initialValues.shipper_data = copyTicketDto.shipper_data;

  if (!!copyTicketDto.shipper_data.notification_transports[0]) {
    if (
      copyTicketDto.shipper_data.notification_transports[0].transport ===
      'whatsapp'
    ) {
      initialValues.custom.transport.selected_notification_transport =
        'whatsapp';
      initialValues.custom.transport.phone =
        copyTicketDto.shipper_data.notification_transports[0].phone_number;
    }
    if (
      copyTicketDto.shipper_data.notification_transports[0].transport ===
      'email'
    ) {
      initialValues.custom.transport.selected_notification_transport = 'email';
      initialValues.custom.transport.email =
        copyTicketDto.shipper_data.notification_transports[0].email;
    }
  }
  // fill order_data
  //   loads
  initialValues.order_data.loads_data = copyTicketDto.order_data.loads_data;
  initialValues.order_data.loads_data.loads =
    copyTicketDto.order_data.loads_data.loads.map((l) => {
      return {
        ...l,
        item_length: convertNullToEmptyString(l.item_leght),
        item_height: convertNullToEmptyString(l.item_height),
        item_width: convertNullToEmptyString(l.item_width),
      };
    });
  initialValues.order_data.loads_data.totals = {
    cubic_meters: convertNullToEmptyString(
      copyTicketDto.order_data.loads_data.cubic_meters
    ),
    linear_meters: convertNullToEmptyString(
      copyTicketDto.order_data.loads_data.linear_meters
    ),
    total_weight: convertNullToEmptyString(
      copyTicketDto.order_data.loads_data.total_weight
    ),
  };
  // pickup
  initialValues.order_data.pickup = copyTicketDto.order_data.pickup;
  initialValues.order_data.pickup.time_from = cleanTimeFromBackend(
    copyTicketDto.order_data.pickup.time_from
  );
  initialValues.order_data.pickup.time_to = cleanTimeFromBackend(
    copyTicketDto.order_data.pickup.time_to
  );
  //  dropoff
  initialValues.order_data.dropoff = copyTicketDto.order_data.dropoff;
  initialValues.order_data.dropoff.time_from = cleanTimeFromBackend(
    copyTicketDto.order_data.dropoff.time_from
  );
  initialValues.order_data.dropoff.time_to = cleanTimeFromBackend(
    copyTicketDto.order_data.dropoff.time_to
  ); // service_type
  initialValues.order_data.service_type = copyTicketDto.order_data.service_type;
  // complementary

  const [additionalServices, otherAdditionalServices] = splitAdditionalServices(
    copyTicketDto.order_data.complementary_info.additional_services
  );

  initialValues.order_data.complementary_info.additional_services =
    additionalServices;
  initialValues.order_data.complementary_info.other_additional_services =
    otherAdditionalServices;
  initialValues.order_data.complementary_info.customer_internal_reference =
    copyTicketDto.order_data.complementary_info.customer_internal_reference;

  const deadline =
    copyTicketDto.order_data.complementary_info.customer_deadline;
  const separatedDeadline = getSeparateDateAndTimeFromDatetime({
    dateTime: deadline,
  });
  initialValues.order_data.complementary_info.customer_deadline_date =
    separatedDeadline.date;
  initialValues.order_data.complementary_info.customer_deadline_time =
    separatedDeadline.time;

  return initialValues;
};

const getUpdateableFieldsFromTicketObject = (ticketObject) => {
  return {
    shipper_data: {
      company_name: ticketObject.shipper_data.company_name,
      company_id: ticketObject.shipper_data.company_id,
      contact_name: ticketObject.shipper_data.contact_name,
      phone: ticketObject.shipper_data.phone,
      notification_transports:
        ticketObject.shipper_data.notification_transports,
    },
    order_data: {
      pickup: {
        zipcode: ticketObject.order_data.pickup.zipcode,
        observations: ticketObject.order_data.pickup.observations,
      },
      dropoff: {
        zipcode: ticketObject.order_data.dropoff.zipcode,
        observations: ticketObject.order_data.dropoff.observations,
      },
      service_type: {
        vehicle_type: ticketObject.order_data.service_type.vehicle_type,
        vehicle_details: ticketObject.order_data.service_type.vehicle_details,
      },
      complementary_info: {
        customer_deadline:
          ticketObject.order_data.complementary_info.customer_deadline,
        customer_internal_reference:
          ticketObject.order_data.complementary_info
            .customer_internal_reference,
        additional_services:
          ticketObject.order_data.complementary_info.additional_services,
      },
    },
  };
};

const dataTransformation = {
  getTicketDtoFromFormValues,
  getInitialFormValuesFromTicketDto,
  getUpdateableFieldsFromTicketObject,
};

//
//
//
//
//
//
// callBackend
//
//
//
//
//
//
//

// calls api to create a new Ticket
const createNewTicket = async ({ ticketDto }) => {
  return createNewTicketAPICall({ ticketDto });
};

// calls api to get ticketDetail
const getTicketDetail = async ({ id }) => {
  return getTicketDetailApiCall({ id });
};

// calls api to update ticketDetail
const updateTicketDetail = async ({ id, updateTicketDetailDto }) => {
  return updateTicketDetailApiCall({ id, updateTicketDetailDto });
};

// calls api to cancel a Ticket
const cancelTicket = async ({ id, feedBackDTO }) => {
  return cancelTicketApiCall({ id, feedBackDTO });
};

// calls api to move a Ticket to TMS
const moveTicketToTMS = async ({ id, orderIdDTO }) => {
  return moveTicketToTMSApiCall({ id, orderIdDTO });
};

const callBackend = {
  createNewTicket,
  getTicketDetail,
  updateTicketDetail,
  cancelTicket,
  moveTicketToTMS,
};

//
//
//
//
//
//
// ticketService
//
//
//
//
//
//
//

const ticketService = {
  defaultValues,
  utils,
  bussiness,
  dataTransformation,
  callBackend,
};

export default ticketService;
